import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export interface OnboardingClientSubmittedProps extends EventProps {
    account_type: string
    access_level?: string
}

export const OnboardingClientSubmittedAnalytics = createAnalyticsStatic<OnboardingClientSubmittedProps>(
    ANALYTICS_EVENTS.ONBOARDING.ONBOARDING_CLIENT_SUBMITTED,
)

export default OnboardingClientSubmittedAnalytics
